import * as React from 'react';
import { useDispatch } from 'react-redux';

import { closeSearchResultsSidebar } from '../../../common/actions/searchResults';
import { SidebarCommonHeader } from '../../components/SidebarCommonHeader';

export const SidebarCommonHeaderContainer: React.FC = () => {
  const dispatch = useDispatch();

  const handleClose = React.useCallback(() => {
    dispatch(closeSearchResultsSidebar());
  }, [dispatch]);

  return <SidebarCommonHeader onClose={handleClose} />;
};

SidebarCommonHeaderContainer.displayName = 'SidebarCommonHeaderContainer';
